import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FocusService } from "src/standard/services/focus.service";
import { findParentElement } from "src/standard/ts/findParentElement";
import invariant from "tiny-invariant";

@Component({
  standalone: true,
  selector: "standard-skip-nav-link",
  template: `<a href="#skip-nav" (click)="onClick($event)" i18n
    >Skip to content</a
  >`,
  styles: `
    a {
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      width: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      position: absolute;

      &:focus {
        padding: 1rem;
        position: fixed;
        top: 10px;
        left: 10px;
        background: white;
        z-index: 99999; // top top
        width: auto;
        height: auto;
        clip: auto;
        border-radius: var(--bs-border-radius);
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardSkipNavLinkComponent {
  private focusService = inject(FocusService);

  // this is not async because html won't respect us
  onClick(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    const skipToEls = document.querySelectorAll("#skip-nav");
    invariant(skipToEls.length);
    const skipToEl = skipToEls[skipToEls.length - 1] as HTMLElement;
    const parentMain = findParentElement(skipToEl, "main");
    invariant(parentMain);
    this.focusService.focusFirst(parentMain);
  }
}
